<template>
  <div class="gd-aside" :class="{ 'open' : asideOpen }">
    <div class="gd-aside__toggler" @click="asideFunction()">---<br>---<br>---</div>
    <!-- <div class="gd-aside__title">Menu</div> -->
    <ul class="gd-aside__menu">
      <li class="gd-aside__menu-item">
        <router-link
          :to="{ name: 'Home' }"
          class="gd-aside__menu-link"
          :class="{ 'active-link' : activeLink === 'Home' }">
          Drivers
          <span class="gd-aside__menu-icon-container">
            <IconChevronRight class="gd-aside__menu-icon"></IconChevronRight>
          </span>
        </router-link>
      </li>
      <li class="gd-aside__menu-item">
        <router-link
          :to="{ name: 'ladHome' }"
          class="gd-aside__menu-link"
          :class="{ 'active-link' : activeLink === 'Lad' }">
          Parseur
          <span class="gd-aside__menu-icon-container">
            <IconChevronRight class="gd-aside__menu-icon"></IconChevronRight>
          </span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import IconChevronRight from '@/assets/svg/icon-chevron-right.svg';

export default {
  name: 'gd-aside',

  components: {
    IconChevronRight,
  },

  data() {
    return {
      activeLink: undefined,
      asideOpen: false,
    };
  },

  methods: {
    asideFunction() {
      this.asideOpen = !this.asideOpen;
    },
  },

  mounted() {
    if (this.$route.name === 'ladHome' || this.$route.name === 'ladCreate' || this.$route.name === 'ladUpdate') {
      this.activeLink = 'Lad';
    } else {
      this.activeLink = 'Home';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue